import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const routePaths = createModuleRoutePaths({
  resource: ResourceEnum.StockMove,
});

export const STOCK_MOVE_OPERATIONS_ENUM = {
  InOperationBuying: "InOperationBuying",
  InOperationInventory: "InOperationInventory",
  InOperationReturn: "InOperationReturn",
  InOperationAdjustment: "InOperationAdjustment",
  OutOperationInventory: "OutOperationInventory",
  OutOperationBestBeforeDate: "OutOperationBestBeforeDate",
  OutOperationPromotion: "OutOperationPromotion",
  OutOperationAdjustment: "OutOperationAdjustment",
  TransferOperation: "TransferOperation",
  TransferOperationOwner: "TransferOperationOwner",
};
